import { Form, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { requestPassword } from '../../modules/auth/_requests';

const initialValues = {
  email: '',
};

const ForgotForm = () => {
  const { t } = useTranslation(['auth'], { keyPrefix: 'form' });
  const { t: b } = useTranslation(['auth'], { keyPrefix: 'button' });
  const navigate = useNavigate();

  const forgotPasswordSchema = Yup.object().shape({
    email: Yup.string()
      .email(t('email.invalid'))
      .min(3, t('email.invalid'))
      .max(50, t('email.invalid'))
      .required(t('email.required')),
  });

  const formik = useFormik({
    initialValues,
    validationSchema: forgotPasswordSchema,
    onSubmit: async (values, { setSubmitting }) => {
      try {
        await requestPassword(values.email);
      } catch (error: unknown) {
        console.error(error);
        toast.error(t('failed'));
      } finally {
        setSubmitting(false);
      }
    },
  });

  return (
    <Form
      noValidate
      onSubmit={formik.handleSubmit}
      style={{ minWidth: '300px' }}
    >
      <Form.Group controlId="formBasicEmail" className="mb-3">
        <Form.Label>{t('email.label')}</Form.Label>
        <Form.Control
          type="email"
          placeholder={t('email.placeholder')}
          {...formik.getFieldProps('email')}
          isInvalid={formik.touched.email && formik.errors.email !== undefined}
        />
        <Form.Control.Feedback type="invalid">
          {formik.errors.email}
        </Form.Control.Feedback>
      </Form.Group>

      <div className="d-flex justify-content-end gap-2">
        <Button
          variant="outline-dark"
          onClick={() => navigate('/login')}
          className="text-end"
          disabled={formik.isSubmitting}
        >
          {b('cancel')}
        </Button>
        <Button
          variant="outline-dark"
          type="submit"
          className="text-end"
          disabled={formik.isSubmitting || !formik.isValid}
        >
          {b(formik.isSubmitting ? 'wait' : 'submit')}
        </Button>
      </div>
    </Form>
  );
};

export default ForgotForm;
